import { render, staticRenderFns } from "./EditInitPwd.vue?vue&type=template&id=2db2c5c4&scoped=true&"
import script from "./EditInitPwd.vue?vue&type=script&lang=js&"
export * from "./EditInitPwd.vue?vue&type=script&lang=js&"
import style0 from "./EditInitPwd.vue?vue&type=style&index=0&id=2db2c5c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db2c5c4",
  null
  
)

export default component.exports